// QR codes for the tables (QR ordering): drawn as SVG from the code's modules,
// so they print sharp at any size and need no image.
import qrcode from 'qrcode-generator'

// A payment QR may hold text beyond ASCII (a shop's name): the library's default
// keeps one byte per character and would redraw a different code.
qrcode.stringToBytes = (text: string) => [...new TextEncoder().encode(text)]

/** The dark squares of a QR code for `value`, as one SVG path over a `size`-module grid. */
export function qrPath(value: string): { size: number; path: string } {
  const qr = qrcode(0, 'M')
  qr.addData(value)
  qr.make()
  const size = qr.getModuleCount()
  let path = ''
  for (let row = 0; row < size; row++) {
    for (let col = 0; col < size; col++) {
      if (qr.isDark(row, col)) path += `M${col} ${row}h1v1h-1z`
    }
  }
  return { size, path }
}

export function QrCode({ value, label }: { value: string; label: string }) {
  const { size, path } = qrPath(value)
  // A quiet zone of four modules around the code, as scanners expect.
  const quiet = 4
  return (
    <svg
      role="img"
      aria-label={label}
      viewBox={`${-quiet} ${-quiet} ${size + quiet * 2} ${size + quiet * 2}`}
      style={{ width: '100%', height: 'auto', display: 'block', background: '#fff' }}
      shapeRendering="crispEdges"
    >
      <path d={path} fill="#000" />
    </svg>
  )
}

export interface TableCode {
  table_id: string
  name: string
  url: string
}

/** An A4 sheet of table codes to cut out: six to a page. */
export function QrSheet({ codes, businessName }: { codes: TableCode[]; businessName: string }) {
  return (
    <div
      style={{
        font: '12px/1.4 system-ui, sans-serif',
        color: '#000',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '8mm',
      }}
    >
      {codes.map((c) => (
        <div
          key={c.table_id}
          style={{
            border: '1px dashed #999',
            borderRadius: 8,
            padding: '6mm',
            textAlign: 'center',
            breakInside: 'avoid',
          }}
        >
          <div style={{ fontWeight: 700, fontSize: 14 }}>{businessName}</div>
          <div style={{ width: '52mm', margin: '4mm auto' }}>
            <QrCode value={c.url} label={`QR code for ${c.name}`} />
          </div>
          <div style={{ fontWeight: 800, fontSize: 22 }}>{c.name}</div>
          <div>Scan to see the menu and order</div>
        </div>
      ))}
    </div>
  )
}
